import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref } from "vue";
import Meeting from "@/services/meeting";

export function useMeetingAttendees(meetingId: Ref<string | undefined>) {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["meetingAttendees", meetingId],
    queryFn: () => Meeting.getMeetingAttendees(meetingId.value!),
    enabled: computed(() => !!meetingId.value),
    staleTime: 30_000,
  });

  const attendees = computed(() => data.value?.data?.data ?? []);

  return { attendees, isLoading, refetch };
}
